export type SessionStatus = "waiting" | "listening" | "ended";

export interface UtteranceEvent {
  type: "utterance";
  id: string; // stable per segment
  speaker: 1 | 2;
  text?: string; // original text update
  finalText?: boolean; // STT finalized
  translation?: string; // translated text update
  translationError?: boolean; // mark failure
  confidence?: number; // 0..1
  ts?: number; // epoch ms
  lang?: string;
}

export interface StatusEvent {
  type: "status";
  status: SessionStatus;
}

export type BroadcastEvent = UtteranceEvent | StatusEvent;
export interface ConfigEvent {
  type: "config";
  languages: { s1: string; s2: string };
}

export type AnyEvent = BroadcastEvent | ConfigEvent;

export function openSessionChannel(sessionId: string) {
  return new BroadcastChannel(`sess-${sessionId}`);
}
